import { nonNullable } from './nonNullable';

const SUBITEMS_KEY = 'routes';

export const isAppRouteSingleType = (
  route: unknown
): route is AppRouteSingleType => {
  return !!route && typeof route === 'object' && !(SUBITEMS_KEY in route);
};

export const isAppRouteGroupType = (
  route: unknown
): route is AppRouteGroupType => {
  if (!route || typeof route !== 'object') return false;

  const routes = SUBITEMS_KEY in route && route[SUBITEMS_KEY];
  if (!routes || !Array.isArray(routes)) return false;

  return !!routes.length && routes.every(isAppRouteSingleType);
};

const mergeWithParent = (
  route: AppRouteSingleType,
  parent: AppRouteGroupType
): AppRouteSingleType => {
  return {
    ...route,
    url: route.url,
    groupUrl: parent.groupUrl,

    // self-priority
    component: route.component || parent.component,

    // compose actions into "AND" rule
    action: [route.action, parent.action]
      .filter(nonNullable)
      .flatMap<PermissionType>(a => a),
  };
};

export const extractRoutes = (routes: AppRouteType[]): AppRouteSingleType[] => {
  return routes.flatMap(route => {
    if (isAppRouteSingleType(route)) return [route];
    if (isAppRouteGroupType(route)) {
      return route.routes.map(childRoute => mergeWithParent(childRoute, route));
    }

    return [];
  });
};
